export const byEventId = (a: { eventId?: number }, b: { eventId?: number }): number => {
  const aEventId = a.eventId ?? 0
  const bEventId = b.eventId ?? 0
  return bEventId - aEventId
}

export const byTimestamp = (a: { timestamp?: number }, b: { timestamp?: number }): number => {
  const aTimestamp = a.timestamp ?? Number.MAX_SAFE_INTEGER
  const bTimestamp = b.timestamp ?? Number.MAX_SAFE_INTEGER
  return bTimestamp - aTimestamp
}

export const byRank = (a: { rank?: number }, b: { rank?: number }): number => {
  const aEventId = a.rank ?? Number.MAX_SAFE_INTEGER
  const bEventId = b.rank ?? Number.MAX_SAFE_INTEGER
  return bEventId - aEventId
}
